import React from 'react';

function WidgetCity(props) {
    
    return (
        <div className="widget-city-name">{props.location}</div>
    )
}

export default WidgetCity;